import React, { useEffect, useRef, useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Avatar, IconButton } from "@mui/material";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Input, ReactSelector, TextArea } from "../../components/Form";
import useButtonLoader from "../../hooks/UseButtonLoader";
import toast from "react-hot-toast";
import {
  AddCommunityApi,
  getCommunityDetailsApi,
  updateCommunityApi,
} from "../../services/community";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import AddLocationAltTwoToneIcon from "@mui/icons-material/AddLocationAltTwoTone";
import WrongLocationTwoToneIcon from "@mui/icons-material/WrongLocationTwoTone";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import PermMediaIcon from "@mui/icons-material/PermMedia";
import { usePlacesWidget } from "react-google-autocomplete";
import Address from "./view/Address";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import { cityApi, countryApi, stateApi } from "../../services/masterApi";
import { catchMessage, elseMessage } from "../../comman/Message";

const EditCommunity = () => {
  const { id } = useParams();
  const nationalId = useRef();
  const navigate = useNavigate();
  const [input, setInput] = useState({
    locationType: "",
    communityName: "",
    about: "",
  });
  const [image, setImage] = useState("");
  const [error, setError] = useState({});
  const [buttonref, buttonLoader] = useButtonLoader("Update community");
  const [communityDetails, setCommunityDetails] = useState("");
  const [loader, showLoader, hideLoader] = useFullPageLoader();

  const addressId = Date.now();
  const [selectedAddress, setSelectedAddress] = useState([
    { id: 101, address: "", latitude: "", longitude: "" },
  ]);

  const aadRow = () => {
    const newRow = { id: addressId, address: "", latitude: "", longitude: "" };
    setSelectedAddress((prevAddress) => [...prevAddress, newRow]);
  };
  const [country, setCountry] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [state, setState] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [city, setCity] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");

  // console.log("selected Country", selectedCountry,"selected state", selectedState)
  //------------handle-Country-onChange--------------
  const handleCountry = (event) => {
    setSelectedCountry(event);
    setSelectedState("");
    setSelectedCity("");
    if (!event?.value) {
      setState([]);
      setSelectedState("");
      setCity([]);
      setSelectedCity("");
    }
  };
  //------------handle-state-onChange--------------
  const handleState = (event) => {
    setSelectedState(event);
    setSelectedCity("");
    if (!event?.value) {
      setCity([]);
      setSelectedCity("");
    }
  };

  //----------validation------------
  const validation = () => {
    const imageFileRegex = /\.(jpg|jpeg|png|gif|bmp)$/i;
    let errorMessage = {};
    let status = true;

    if (!input.locationType) {
      // errorMessage["locationType"] = "Please choose Location";
      toast.error("Please choose Location");
      status = false;
    }
    if (!input.communityName) {
      errorMessage["communityName"] = "Please enter community Name";
      status = false;
    }
    if (!input.about) {
      errorMessage["about"] = "Please enter Description";
      status = false;
    } else if (input.about.length < 200) {
      errorMessage["about"] = "Please write a minimum of 200 characters.";
      errorMessage["aboutLength"] = true;
      status = false;
    }

    if (!image?.name && !input?.coverImage) {
      // errorMessage["image"] = "Please choose image";
      toast.error("Please choose cover image");
      status = false;
    }
    if (input?.locationType === "country") {
      if (!selectedCountry?.value) {
        errorMessage["country"] = "Please select country";
        status = false;
      }
    }
    if (input?.locationType === "country") {
      if (!selectedState?.value) {
        errorMessage["state"] = "Please select state";
        status = false;
      }
    }
    if (input?.locationType === "country") {
      if (!selectedCity?.value) {
        errorMessage["city"] = "Please select city";
        status = false;
      }
    }
    setError(errorMessage);
    return status;
  };
  //------------------onChange-input-value---------------------------
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "communityName") {
      // Allow letters, numbers, spaces and special characters; just remove leading spaces and collapse multiple spaces
      const cleanedName = value
        .replace(/^[ ]+/g, "")
        .replace(/\s+/g, " ");
      setInput({ ...input, [name]: cleanedName });
    } else if (name === "locationType") {
      if (value === "world") {
        setSelectedCountry("");
        setSelectedState("");
        setSelectedCity("");
      }
      setInput({ ...input, [name]: value });
    } else if (name === "about") {
      const cleanedName = value.replace(/^[ ]+/g, "");
      setInput({ ...input, [name]: cleanedName });
    }
    // else if (name === "image" && files && files[0]) {
    //     // setInput({ ...input, [name]: value });
    //     setImage(files[0]);
    // } else {
    //     setImage('');
    // }
    else if (name === "image" && files && files[0]) {
      const imageFileRegex = /\.(jpg|jpeg|png)$/i;
      if (!imageFileRegex.test(files[0].name)) {
        toast.error("Only choose image files (jpg, jpeg, png)");
        setImage("");
      } else {
        setImage(files[0]);
      }
    } else {
      setImage("");
    }
  };
  //--------------update-community------------------------
  const updateCommunity = async () => {
    const status = validation();
    if (status) {
      try {
        buttonLoader(true);
        const formData = new FormData();
        formData.append("communityName", input.communityName);
        formData.append("about", input.about);
        formData.append("locationType", input.locationType);
        if (input?.locationType === "country") {
          formData.append(
            "country",
            JSON.stringify({
              _id: selectedCountry?.value,
              name: selectedCountry?.label,
            })
          );
          formData.append(
            "state",
            JSON.stringify({
              _id: selectedState?.value,
              name: selectedState?.label,
            })
          );
          formData.append(
            "city",
            JSON.stringify({
              _id: selectedCity?.value,
              name: selectedCity?.label,
            })
          );
        }
        const res = await updateCommunityApi(id, formData);
        if (res.data.status === 200) {
          toast.success(res.data.message);
          // modalClose()
          navigate(-1);
          buttonLoader(false);
        } else {
          toast.error(res.data.message);
          buttonLoader(false);
        }
      } catch (e) {
        toast.error(e.message);
        buttonLoader(false);
      }
    }
  };

  //**********get community detail**********
  const getSingleCommunity = async () => {
    try {
      showLoader();
      const res = await getCommunityDetailsApi(id);
      if (res?.data?.status === 200) {
        hideLoader();
        setInput(res?.data?.data?.community);
        setImage(res?.data?.data?.community?.coverImage);

        if (res?.data?.data?.community?.locationType === "country") {
          // const country = JSON.parse(res?.data?.data?.community?.country) || {}
          // const state = JSON.parse(res?.data?.data?.community?.state) || {}
          // const city = JSON.parse(res?.data?.data?.community?.city) || {}
          const country = res?.data?.data?.community?.country || {};
          const state = res?.data?.data?.community?.state || {};
          const city = res?.data?.data?.community?.city || {};

          setSelectedCountry({ label: country?.name, value: country?._id });
          setSelectedState({ label: state?.name, value: state?._id });
          setSelectedCity({ label: city?.name, value: city?._id });
        }
      } else {
        toast.error(res.message);
        hideLoader();
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
      hideLoader();
    }
  };

  //--------------country-listing------------------------
  useEffect(() => {
    const fathCountry = async () => {
      try {
        const res = await countryApi();
        if (res?.data?.status === 200) {
          const data = res?.data?.data?.country_list || [];
          const country = data?.map(({ _id, name }) => ({
            label: name,
            value: _id,
          }));
          setCountry(country);
        } else {
          elseMessage(res);
        }
      } catch (err) {
        catchMessage(err);
      }
    };
    fathCountry();
  }, []);
  //--------------state-listing------------------------
  useEffect(() => {
    const fathState = async (countryId = selectedCountry?.value) => {
      if (selectedCountry?.value) {
        try {
          const res = await stateApi({ countryId });
          if (res?.data?.status === 200) {
            const data = res?.data?.data?.state_list || [];
            const state = data?.map(({ _id, name }) => ({
              label: name,
              value: _id,
            }));
            setState(state);
          } else {
            elseMessage(res);
          }
        } catch (err) {
          catchMessage(err);
        }
      }
    };
    if (selectedCountry?.value) {
      fathState(selectedCountry?.value);
    }
  }, [selectedCountry?.value]);
  //--------------city-listing------------------------
  useEffect(() => {
    const fathCity = async (
      countryId = selectedCountry?.value,
      stateId = selectedState?.value
    ) => {
      if (selectedCountry?.value && selectedState?.value) {
        try {
          const res = await cityApi({ countryId, stateId });
          if (res?.data?.status === 200) {
            const data = res?.data?.data?.city_list || [];
            const city = data?.map(({ _id, name }) => ({
              label: name,
              value: _id,
            }));
            setCity(city);
          } else {
            elseMessage(res);
          }
        } catch (err) {
          catchMessage(err);
        }
      }
    };
    if (selectedCountry?.value && selectedState?.value) {
      fathCity(selectedCountry?.value, selectedState?.value);
    }
  }, [selectedCountry?.value, selectedState?.value]);

  useEffect(() => {
    getSingleCommunity();
  }, []);
  return (
    <div className="WrapperArea">
      {loader}
      <div className="WrapperBox">
        <div className="TitleBox">
          <h4 className="Title">
            <Link to={-1}>
              <IconButton>
                <ArrowBackIcon sx={{ color: "#C86337", fontSize: 30 }} />
              </IconButton>
            </Link>
            Update Community
          </h4>
        </div>

        <div className="row">
          <div className="col-7 mb-4">
            <div className="row">
              <div className="col-12">
                <input
                  type="file"
                  // label="Choose National Id"
                  name="image"
                  className="form-control"
                  accept="image/*"
                  onChange={handleChange}
                  ref={nationalId}
                  hidden
                  error={error.image}
                />
                <div>
                  <label className=" text-dark">Cover Image</label>
                  {image && image?.name ? (
                    <Avatar
                      onClick={() => {
                        nationalId?.current?.click();
                      }}
                      variant="rounded"
                      id={input?._id}
                      alt={input?.name}
                      src={URL.createObjectURL(image)}
                      role="button"
                      sx={{
                        height: 250,
                        width: "auto",
                        borderRadius: 1,
                        border: "1px solid #C86337",
                      }}
                    >
                      <InsertPhotoIcon sx={{ fontSize: 60 }} />
                    </Avatar>
                  ) : (
                    <div>
                      <Avatar
                        className="w-100"
                        variant="rounded"
                        onClick={() => {
                          nationalId?.current?.click();
                        }}
                        src={input?.coverImage}
                        sx={{
                          height: 250,
                          cursor: "pointer",
                          border: "2px dotted #C86337",
                          borderRadius: 2,
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          color: "#C86337",
                        }}
                      >
                        <PermMediaIcon sx={{ fontSize: 100 }} />
                        <div>
                          <p className="mt-2">Upload Community Cover Image</p>
                          <p
                            style={{
                              fontSize: "12px",
                              marginTop: "10px",
                              textAlign: "center",
                            }}
                          >
                            Minimum 343px Width 185px Height. Max 10MB
                          </p>
                        </div>
                      </Avatar>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="col-5">
            <div className="row">
              <div className="col-12 mb-3">
                <label htmlFor="">Location</label>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="locationType"
                  value={input?.locationType || ""}
                  onChange={handleChange}
                >
                  <FormControlLabel
                    value="country"
                    control={<Radio />}
                    label="Country"
                  />
                  <FormControlLabel
                    value="world"
                    control={<Radio />}
                    label="World wide"
                  />
                </RadioGroup>
              </div>
              <div className="col-12 mb-3">
                <Input
                  type="text"
                  name="communityName"
                  value={input?.communityName || ""}
                  onChange={handleChange}
                  placeholder="Enter community Name"
                  className="form-control"
                  label="community Name"
                  error={error.communityName}
                  maxLength={30}
                />
              </div>
              <div className="col-12 mb-3">
                <TextArea
                  type="text"
                  name="about"
                  value={input?.about || ""}
                  onChange={handleChange}
                  placeholder="Enter Description"
                  className={`form-control `}
                  label="Description"
                  error={error.about}
                  extraErr={error?.aboutLength}
                  // maxLength={1000}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          {input?.locationType === "country" && (
            <>
              <div className="col-4 mb-4">
                <ReactSelector
                  label="Country"
                  name="country"
                  placeholder={"search country"}
                  value={selectedCountry || ""}
                  className={
                    error?.country && !selectedCountry?.value
                      ? "form-control"
                      : ""
                  }
                  option={country}
                  onChange={handleCountry}
                  error={error?.country}
                />
              </div>
              <div className="col-4 mb-4">
                <ReactSelector
                  label="State"
                  name="state"
                  value={selectedState || ""}
                  className={
                    error?.state && !selectedState?.value ? "form-control" : ""
                  }
                  option={state}
                  onChange={handleState}
                  error={error?.state}
                  placeholder={"Select State"}
                />
              </div>
              <div className="col-4 mb-4">
                <ReactSelector
                  label="City"
                  name="city"
                  value={selectedCity || ""}
                  className={
                    error?.city && !selectedCity?.value ? "form-control" : ""
                  }
                  option={city}
                  onChange={(event) => setSelectedCity(event)}
                  error={error?.city}
                />
              </div>
            </>
          )}
        </div>
        <button className="btn_size" onClick={updateCommunity} ref={buttonref}>
          Update Community
        </button>
      </div>
    </div>
  );
};

export default EditCommunity;
